import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import apiRequest from '@utils/apiRequest'
import Emitter from '@utils/eventEmitter'

export const getMemberList = createAsyncThunk(
  'GET_MEMBER_LIST',
  async (params) => {
    let options = {
      method: 'GET',
      url: `${process.env.REACT_APP_AP_CLIENT_SERVER_HOST}/member`,
      params
    }
    let response = await apiRequest(options)
    if (response.__isError) {
      return
    }
    return {
      data: response,
    }
  }
)

export const getMemberIsCreate = createAsyncThunk(
  'GET_MEMBER_IS_CREATE',
  async (params) => {
    let options = {
      method: 'GET',
      url: `${process.env.REACT_APP_AP_CLIENT_SERVER_HOST}/member/iscreate`,
      params
    }
    let response = await apiRequest(options)
    if (response.__isError) {
      return
    }
    return {
      data: response,
    }
  }
)

export const getManageCompanyList = createAsyncThunk(
  'GET_MANAGE_COMPANY_LIST',
  async (params) => {
    let options = {
      method: 'GET',
      url: `${process.env.REACT_APP_AP_CLIENT_SERVER_HOST}/member/company`,
      params
    }
    let response = await apiRequest(options)
    if (response.__isError) {
      return
    }
    return {
      data: response ,
    }
  }
)

export const createMember = createAsyncThunk(
  'CREATE_MEMBER',
  async (data) => {
    let options = {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      method: 'POST',
      url: `${process.env.REACT_APP_AP_CLIENT_SERVER_HOST}/member`,
      data
    }
    let response = await apiRequest(options)
    if (response.__isError) {
      return
    }
    return {
      data
    }
  }
)

export const updateMember = createAsyncThunk(
  'UPDATE_MEMBER',
  async (data) => {
    let options = {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      method: 'PUT',
      url: `${process.env.REACT_APP_AP_CLIENT_SERVER_HOST}/member/${data.companyMemberCode}`,
      data: data.form
    }
    let response = await apiRequest(options)
    if (response.__isError) {
      return
    }
    return {
      data: response,
    }
  }
)

export const bulkUpdateMemberAttach = createAsyncThunk(
  'BULK_UPDATE_MEMBER_ATTACH',
  async (data) => {
    let options = {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      method: 'POST',
      url: `${process.env.REACT_APP_AP_CLIENT_SERVER_HOST}/member/bulkattach`,
      data: data.form
    }
    let response = await apiRequest(options)
    if (response.__isError) {
      return
    }
    return {
      data: response,
    }
  }
)

export const downloadMemberAttach = createAsyncThunk(
  'DOWNLOAD_MEMBER_ATTACH',
  async (params) => {
    let options = {
      method: 'GET',
      url: `${process.env.REACT_APP_AP_CLIENT_SERVER_HOST}/member/attach`,
      params: {
        memberCode: params.memberCode,
        companyMemberCode: params.companyMemberCode,
        type: params.type
      },
      responseType: 'blob',
    }
    let response = await apiRequest(options)
    if (response.__isError) {
      return
    }
    return {
      fileName: params.fileName,
      data: response
    }
  }
)

const memberSlice = createSlice({
  name: 'member',
  initialState: {
    isLoading: false,
    memberList: [],
    memberListTotalSize: 0,
    isCreate: false,
    curMemberCode: '',
    isRefresh: false,
  },
  reducers: {
    clearMemberList: (state) => {
      state.memberList = []
      state.memberListTotalSize = 0
    },
    clearIsCreate: (state) => {
      state.isCreate = false
    },
    clearManageCompanyList: (state) => {
      state.manageCompanyList = []
    },
    clearMemberCode: (state) => {
      state.curMemberCode = ''
    }
  },
  extraReducers: {
    [getMemberList.pending]: (state) => {
      state.isLoading = true
    },
    [getMemberList.rejected]: (state) => {
      state.isLoading = false
    },
    [getMemberList.fulfilled]: (state, { payload }) => {
      state.isLoading = false
      state.isRefresh = false
      state.memberListTotalSize = payload.data.totalElements
      state.memberList = payload.data.content
    },
    [getManageCompanyList.pending]: (state) => {
      state.isLoading = true
    },
    [getManageCompanyList.rejected]: (state) => {
      state.isLoading = false
    },
    [getManageCompanyList.fulfilled]: (state, { payload }) => {
      state.isLoading = false
      state.manageCompanyList = payload.data
    },
    [getMemberIsCreate.pending]: (state) => {
      state.isLoading = true
    },
    [getMemberIsCreate.rejected]: (state) => {
      state.isLoading = false
    },
    [getMemberIsCreate.fulfilled]: (state, { payload }) => {
      state.isLoading = false
      state.curMemberCode = payload
    },
    [createMember.fulfilled]: (state, { payload }) => {
      if (!payload) {
        return
      }

      Emitter.emit('SHOW_MESSAGE', {
        text: `등록되었습니다.`
      })

      state.isRefresh = true
    },
    [updateMember.fulfilled]: (state, { payload }) => {
      if (!payload) {
        return
      }

      Emitter.emit('SHOW_MESSAGE', {
        text: `변경되었습니다.`
      })

      state.memberList = state.memberList.map(member => {
        if (member.companyMemberCode === payload.data.companyMemberCode) {
          return payload.data
        } else {
          return member
        }
      })
    },
    [bulkUpdateMemberAttach.fulfilled]: (state, { payload }) => {
      if (!payload) {
        return
      }

      Emitter.emit('SHOW_MESSAGE', {
        text: `일괄등록 되었습니다.`
      })

      state.isRefresh = true
    },
    [downloadMemberAttach.fulfilled]: (state, { payload }) => {
      if (!payload) {
        return
      }

      const url = window.URL.createObjectURL(new Blob([payload.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', payload.fileName) //or any
      // other extension
      document.body.appendChild(link)
      link.click()
      setTimeout(() => {
        link.parentNode.removeChild(link)
      })

      Emitter.emit('SHOW_MESSAGE', {
        text: `다운로드가 완료 되었습니다.`
      })
    },
  }
})

export const { clearMemberList, clearIsCreate, clearManageCompanyList, clearMemberCode } = memberSlice.actions

export default memberSlice.reducer